import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class DesksGetStartedRoute extends Route {
  @service state;
  @service store;
  @service router;
  @service transitionConfirm;
  @service featureFlags;
  @service featureConfig;
  @service abilities;

  beforeModel() {
    if (this.abilities.cannot('visit-settings desks')) {
      this.router.transitionTo('unauthorized');
    }

    if (this.abilities.can('use generic resource')) {
      this.router.transitionTo('resources.resource-type.settings', 1);
    }
  }

  async model() {
    const desksModel = this.modelFor('desks');
    await this.store.findRecord('desk-location', this.state.currentLocationEnabledDesks.id, {
      reload: true,
      include: 'workplace-days',
    });
    const workplaceDays = this.store
      .peekAll('workplaceDay')
      .filter((day) => {
        return day.belongsTo('deskLocation').id() === this.state.currentLocationEnabledDesks.id;
      })
      .sort((a, b) => a.id - b.id);
    return { ...desksModel, workplaceDays };
  }

  redirect() {
    const { currentLocationEnabledDesks } = this.state;
    const canAccessDesksApplication = !!this.state.features?.canAccessDesksApplication;

    if ((!this.featureConfig.isEnabled('desks') && !canAccessDesksApplication) || !currentLocationEnabledDesks.active) {
      this.router.transitionTo('desks.landing-page');
    }
  }
}
